import { Category } from './enums';
import { THEME_KEYS, ThemeKey } from './themeColors';

export const CATEGORY_PROMPTS: Record<Category, string> = {
  [Category.WomensFashion]: "Create an online store specializing in women's fashion and apparel.",
  [Category.MensFashion]: "Create an online store specializing in men's fashion and apparel.",
  [Category.JewelryAccessories]: 'Create an online store specializing in jewelry and fashion accessories.',
  [Category.KidsBabies]: 'Create an online store specializing in products for kids and babies.',
  [Category.BeautyHealth]: 'Create an online store specializing in beauty, wellness, and health products.',
  [Category.HomeGarden]: 'Create an online store specializing in home and garden products.',
  [Category.SportsEntertainment]: 'Create an online store specializing in sports and entertainment products.',
  [Category.BagsLuggage]: 'Create an online store specializing in bags, luggage, and travel accessories.',
  [Category.ConsumerElectronics]: 'Create an online store specializing in consumer electronics and tech accessories.',
  [Category.Pets]: 'Create an online store specializing in pet products and accessories.',
};

export const THEME_PROMPTS: Record<ThemeKey, string> = {
  [THEME_KEYS.RECOMMENDED]:
    'Use a crisp, polished, and professional visual style with the color palette rgb(131, 188, 201), rgb(251, 248, 242), rgb(178, 163, 133), and rgb(66, 60, 57).',
  [THEME_KEYS.CREAMY]:
    'Use a warm, inviting, and artisan-inspired visual style with the color palette rgb(110, 25, 25), rgb(228, 197, 138), rgb(240, 132, 117), and rgb(225, 217, 199).',
  [THEME_KEYS.CONTEMPORARY]:
    'Use a bold, modern, and structured visual style with the color palette rgb(255, 248, 241), rgb(224, 190, 154), rgb(91, 77, 67), and rgb(162, 103, 45).',
  [THEME_KEYS.MATURE]:
    'Use a serene, thoughtful, and refined visual style with the color palette rgb(99, 55, 97), rgb(254, 230, 196), rgb(48, 87, 78), and rgb(145, 171, 165).',
  [THEME_KEYS.NOSTALGIC]:
    'Use a confident, memorable, and nostalgic visual style with the color palette rgb(194, 39, 75), rgb(255, 240, 236), rgb(180, 200, 220), and rgb(85, 107, 141).',
  [THEME_KEYS.TECHNICAL]:
    'Use an energetic, creative, and technical visual style with the color palette rgb(32, 97, 183), rgb(189, 233, 251), rgb(234, 224, 218), and rgb(208, 224, 205).',
};
